<script setup lang="ts">
import {SecretShareInfo} from "@/types";
import {computed, ref} from "vue";
import {getCourseType} from "@/utils/common.ts";
import {ElNotification} from "element-plus";

const visible = ref(false)
const secretShareInfo = ref<SecretShareInfo>()

const clipboard = navigator.clipboard || {
    writeText: (text: string) => {
      let copyInput = document.createElement("input");
      copyInput.value = text;
      document.body.appendChild(copyInput);
      copyInput.select();
      document.execCommand("copy");
      document.body.removeChild(copyInput);
    }
}

const showDialog = (secretInfo: SecretShareInfo) => {
  secretShareInfo.value = secretInfo
  visible.value = true
}

const hideDialog = () => {
  visible.value = false
}

const allInfo = computed(() => {
  return (
      "标题：" +
      secretShareInfo.value?.title +
      "\n简介：" +
      secretShareInfo.value?.short_detail +
      "\n时间：" +
      secretShareInfo.value?.sign_time +
      "\n口令：" +
      secretShareInfo.value?.secret_key
  )
})

const copyAll = () => {
  clipboard.writeText(allInfo.value)
  ElNotification.success({
    message: "全部信息已复制到剪切板",
  })
}

const copySecret = () => {
  clipboard.writeText(secretShareInfo.value?.secret_key || "")
  ElNotification.success({
    message: "课程口令已复制到剪切板",
  })
}

defineExpose({
  showDialog,
  hideDialog
})
</script>

<template>
  <el-dialog title="私密课信息" v-model="visible" align-center>
    <el-form v-if="secretShareInfo">
      <el-form-item label="标题：">
        {{ secretShareInfo.title }}
      </el-form-item>
      <el-form-item label="类型：">
        {{ getCourseType(secretShareInfo.type) }}
      </el-form-item>
      <el-form-item label="简介：">
        {{ secretShareInfo.short_detail }}
      </el-form-item>
      <el-form-item label="上课时间：">
        {{ secretShareInfo.sign_time }}
      </el-form-item>
      <el-form-item label="密钥：">
        {{ secretShareInfo.secret_key }}
      </el-form-item>
      <div class="mt-1rem flex justify-center items-center">
        <el-button type="primary" @click="copyAll">复制全部信息</el-button>
        <el-button type="primary" @click="copySecret" plain>复制课程口令</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<style scoped>
</style>
